module.exports = __webpack_public_path__ + "img/Undo-icon.3c6b7bfe.svg";